import React from "react";
import { Table } from "react-bootstrap";
import moment from "moment";

function DevicesTable({ devices }) {
  return (
    <Table bordered striped>
      <thead>
        <tr>
          <th>Data de registro</th>
          <th>CookieId</th>
          <th>Usuário</th>
          <th>Descrição</th>
        </tr>
      </thead>
      <tbody>
        {devices.map((device, index) => (
          <tr key={index}>
            <td>{moment(device.created_at).format("DD/MM/YYYY HH:M")}</td>
            <td>{device.oc_vwid}</td>
            <td>{device.user_name}</td>
            <td>{device.description}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default DevicesTable;



// WEBPACK FOOTER //
// ./src/components/pages/Devices/DevicesTable.js